import { DELETE_BELEGUNG } from '@/domain/dienstplan/features/VisualEditor/hooks/useBelegungen/graphql/mutations';
import {
  Dienstplan_DeleteBelegungMutation,
  Dienstplan_DeleteBelegungMutationVariables,
} from '@/gql/graphql';
import { useMutation } from '@apollo/client/react';
import { useCallback } from 'react';

export function useDeleteBelegung() {
  const [execute, result] = useMutation<
    Dienstplan_DeleteBelegungMutation,
    Dienstplan_DeleteBelegungMutationVariables
  >(DELETE_BELEGUNG, {
    refetchQueries: [
      'dienstplan_arbeitsbereichByStandortId',
      'dienstplan_getBelegungen',
    ],
    awaitRefetchQueries: true,
  });

  const deleteBelegung = useCallback(
    (variables: Dienstplan_DeleteBelegungMutationVariables) => {
      return execute({ variables });
    },
    [execute],
  );
  return [deleteBelegung, result] as const;
}
